<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/Settings/PasswordChange/index'

export default {
  components: {
    MainComponent
  },

  created () {
    this.$store.commit(`settings/setAttr`, {
      name: 'menuSelected',
      value: 'password-change'
    })
  }
}
</script>
